import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router';

import { trackEvent } from '../../../../services/trackingService';
import Page from '../../../page.jsx';

class PaymentCanceledDetails extends PureComponent {
    componentDidMount() {
        trackEvent('trade.buyer-pays.buyer-cancels-payment');
        this.props.router.replace('/status');
    }

    render() {
        return <Page heading="Betaling avbrutt" />;
    }
}

PaymentCanceledDetails.propTypes = {
    router: PropTypes.object.isRequired,
};

export default withRouter(PaymentCanceledDetails);



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/statusDetails/paymentCanceledDetails.jsx